import moment from "moment";
import React, { useCallback, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import {
  DEFAULT_DATE_TIME_FORMATE,
  getValidUrl,
} from "../../../helpers/global";
import { Link } from "react-router-dom";
import { BoxArrowUpRight } from "react-bootstrap-icons";

const CellValue = ({ returnElement }) => {
  return returnElement || "-";
};

const Cell = ({
  row,
  column: {
    cellColor,
    key,
    label,
    truncate,
    type,
    valueSelector,
    dateFormat = DEFAULT_DATE_TIME_FORMATE,
    width,
  },
  index,
  striped,
  isRowExpanded, // Add isRowExpanded prop
  verticalAlign,
  horizontalAlign,
}) => {
  const value = useMemo(() => (valueSelector ? valueSelector(row) : row[key]), [
    row,
    key,
    valueSelector,
  ]);

  const renderLink = useCallback((isRowExpanded, value, href) => {
    return (
      <div>
        {isRowExpanded ? (
          <a
            className="bg-dark"
            onClick={(e) => e.stopPropagation()}
            href={href}
            style={{ fontSize: 12 }}
          >
            {<CellValue returnElement={value} />}
          </a>
        ) : (
          <CellValue returnElement={value} />
        )}
      </div>
    );
  }, []);

  let returnElement = value;

  switch (type) {
    case "url":
      const urlHref = getValidUrl(value);
      returnElement = isRowExpanded ? (
        <a target="_blank" href={urlHref}>
          {<CellValue returnElement={urlHref} />}
        </a>
      ) : (
        value
      );
      break;
    case "email":
      returnElement = renderLink(isRowExpanded, value, `mailto:${value}`);
      break;
    case "phone":
      returnElement = renderLink(isRowExpanded, value, `tel:${value}`);
      break;
    case "date":
      returnElement = value ? moment(value).format(dateFormat) : null;
      break;
    default:
      break;
  }
  return truncate && returnElement ? (
    <OverlayTrigger
      delay={{ hide: 250, show: 300 }}
      overlay={(props) => (
        <Tooltip {...props}>
          <CellValue returnElement={returnElement} />
        </Tooltip>
      )}
      placement={"left"}
    >
      <td
        className={
          isRowExpanded
            ? "bg-primary-light fw-bold"
            : cellColor
            ? `bg-${cellColor(row)} `
            : striped && index % 2 === 0
            ? "bg-gray"
            : "bg-white"
        }
        style={{ width: width, textAlign: horizontalAlign, verticalAlign }}
      >
        <div
          className="truncate "
          style={{
            width: width,
            fontSize: 12,
            textAlign: "center",
            margin: "0px auto",
          }}
        >
          <CellValue returnElement={returnElement} />
        </div>
      </td>
    </OverlayTrigger>
  ) : (
    <td
      className={
        isRowExpanded
          ? "bg-primary-light fw-bold"
          : cellColor
          ? `bg-${cellColor(row)} `
          : striped && index % 2 === 0
          ? "bg-gray"
          : "bg-white"
      }
      style={{ textAlign: horizontalAlign, verticalAlign, fontSize: 12 }}
    >
      <CellValue returnElement={returnElement} />
    </td>
  );
};

const TableCell = ({
  row,
  column,
  index,
  striped,
  horizontalAlign: defaultHorizontalAlign = "center",
  verticalAlign: defaultVerticalAlign = "middle",
  isRowExpanded,
}) => {
  const {
    horizontalAlign = defaultHorizontalAlign,
    verticalAlign = defaultVerticalAlign,
  } = column;

  const renderCellContent = () => {
    if (column.cellRenderer) {
      return (
        <td
          className={
            isRowExpanded
              ? "bg-light fw-bold"
              : column?.cellColor
              ? `bg-${column?.cellColor(row)} `
              : striped && index % 2 === 0
              ? "bg-gray"
              : "bg-white"
          }
          style={{ textAlign: horizontalAlign, verticalAlign, fontSize: 12 }}
        >
          {column?.key === "jobDesc" ? (
            <Link
              className="smallFont p-1 fw-bold"
              to={`/job/${row?.job?._id}`}
              target="_blank"
            >
             {column.cellRenderer(row) || "-"}  <BoxArrowUpRight className="ml-1" />
            </Link>
          ) : (
            column.cellRenderer(row) || "-"
          )}
        </td>
      );
    } else {
      return (
        <Cell
          row={row}
          column={column}
          index={index}
          striped={striped}
          isRowExpanded={isRowExpanded}
          horizontalAlign={horizontalAlign}
          verticalAlign={verticalAlign}
        />
      );
    }
  };

  return renderCellContent();
};

export default TableCell;
